import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { 
  handlePasswordResetRedirect, 
  processPasswordResetToken, 
  setSessionFromStoredToken
} from './lib/supabase';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

// ログ出力
console.log('App initializing. URL:', window.location.href);
console.log('Pathname:', window.location.pathname);
console.log('Search:', window.location.search);
console.log('Hash:', window.location.hash);

// First, check for password reset redirect
const isHandlingReset = handlePasswordResetRedirect();

// Process token if present in URL
const processToken = async () => {
  try {
    console.log('Processing token from URL...');
    
    // First try to process token from URL
    const result = await processPasswordResetToken();
    console.log('Token processing result:', result.success);
    
    if (!result.success) {
      console.warn('Token processing failed, trying fallback methods');
      
      // Try to set session from stored token as fallback
      const storedResult = await setSessionFromStoredToken();
      if (storedResult.success) {
        console.log('Successfully set session from stored token');
      } else {
        console.error('All token processing methods failed');
      }
    } else {
      // Store tokens in localStorage for future use
      try {
        if (result.session) {
          localStorage.setItem('auth_access_token', result.session.access_token);
          localStorage.setItem('auth_refresh_token', result.session.refresh_token);
          console.log('Stored tokens from successful session');
        }
      } catch (e) {
        console.error('Failed to store tokens:', e);
      }
    }
  } catch (err) {
    console.error('Error processing token:', err);
  } finally {
    // Render the app after token processing, regardless of result
    renderApp();
  }
};

// Function to render the app
const renderApp = () => {
  createRoot(root).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
};

// Check if we're on the reset-password-callback page
if (window.location.pathname === '/reset-password-callback') {
  console.log('On reset-password-callback page, handling specially');
  // Let the component handle it
  renderApp();
} else if (isHandlingReset) {
  console.log('Handling reset redirect, not rendering app yet');
  // Don't render yet, let the redirect happen
} else if (window.location.href.includes('access_token=')) {
  console.log('Found access_token in URL, processing token');
  processToken();
} else {
  console.log('Normal app initialization');
  renderApp();
}